export default __webpack_public_path__ + "static/media/hamburger.daf95225.svg";